import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Primary, PrimaryMedium } from "@ui/components/containers/primary";
import { ChevronDownIcon } from "@ui/components/icons";
import { row, stack } from "@ui/components/layout";
import { Menu } from "@ui/components/menus/menu";

export type ContentLicense = "PREMIUM" | "FREE";
interface ContentSelectorLicenceProps extends React.HTMLAttributes<HTMLDivElement> {
	currentContentLicence: ContentLicense;
	onContentChange: (newContent: ContentLicense) => void;
	isMe?: boolean;
}

export const ContentSelectorLicence: React.FC<ContentSelectorLicenceProps> = ({
	isMe,
	currentContentLicence,
	onContentChange,
	...htmlProps
}) => {
	const wording = (content: ContentLicense): string => I18n.t(`profile.content.${content}`);

	return (
		<Menu
			bottomSheetMode
			closeOnSelect
			align="left"
			{...htmlProps}
			renderMenuContent={() => (
				<Content>
					{(["PREMIUM", "FREE"] as const).map((content) => (
						<Row
							style={{ width: "max-content" }}
							key={content}
							selected={content === currentContentLicence}
							onClick={() => onContentChange(content)}
						>
							{wording(content)}
						</Row>
					))}
				</Content>
			)}
		>
			<Container>
				<div>{wording(currentContentLicence)}</div>
				<ChevronDownIcon />
			</Container>
		</Menu>
	);
};

const Container = styled(Primary)`
	${row(10, "center", "center")};
	padding: 8px 12px;
	border-radius: 18px;
	background-color: ${({ theme }) => theme.colors.lightergray};
	color: ${({ theme }) => theme.colors.textSecondary};
	font-weight: bold;

	> svg {
		width: 14px;
		path {
			fill: ${({ theme }) => theme.colors.textSecondary};
		}
		display: block;
	}
`;

const Content = styled.div`
	${stack(20)}
`;

const Row = styled(PrimaryMedium)<{ selected: boolean }>`
	cursor: pointer;
	${({ selected, theme }) => selected && `color: ${theme.colors.secondary}`};
`;
